// @noflow
import * as Sentry from '@/utils/sentry'

import type { FullWizardRoutes, Route } from '../types/routes'
import WizardRoutes from '../types/routes'

enum StepNumber {
  UserTotalSteps = 12,
  GuestTotalSteps = 15
}

const stepsInFlow = (isGuest: boolean): number => {
  switch (true) {
    case !isGuest:
      return StepNumber.UserTotalSteps
    default:
      return StepNumber.GuestTotalSteps
  }
}

const routeToPercentFilled = ({
  route,
  isGuest
}: {
  route: Route
  isGuest: boolean
}): number => {
  const wizardSteps: Record<FullWizardRoutes, number> = {
    [WizardRoutes.Name]: 1,
    [WizardRoutes.Gender]: 2,
    [WizardRoutes.Age]: 3,
    [WizardRoutes.Breed]: 4,
    [WizardRoutes.Food]: 5,
    [WizardRoutes.Eater]: 6,
    [WizardRoutes.FussinessHelp]: 7,
    [WizardRoutes.Goals]: 8,
    [WizardRoutes.BodyShape]: 9,
    [WizardRoutes.Weight]: 10,
    [WizardRoutes.Activity]: 11,
    [WizardRoutes.Allergies]: 12,
    [WizardRoutes.Health]: 13,
    [WizardRoutes.Snacks]: 14,
    [WizardRoutes.PetParent]: 15
  }

  // The total number of steps in the Wizard for a Guest or User
  const steps = stepsInFlow(isGuest)

  if (!(route in wizardSteps)) {
    Sentry.captureException('Invalid route for Wizard', {
      extra: {
        route
      },
      tags: {
        product: Sentry.Product.Wizard
      }
    })
  }

  // Which step number am I currently on
  const stepIndex = wizardSteps[route as FullWizardRoutes]

  // What percentage of the Wizard have I completed given the
  // number of steps and the current stepIndex I am on
  const stepPercentage = (stepIndex / steps) * 100

  return parseFloat(stepPercentage.toFixed(2))
}

export { routeToPercentFilled, StepNumber, stepsInFlow }
